<template>
  <div class="report-section">
    <h3 class="report-title">Event Reports</h3>

    <div class="report-table-container">
      <table class="report-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Report Name</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td> Event Users Time Spent History</td>
            <td>
              <i class="bx bx-download download-icon" @click="exportFile"></i>
            </td>
          </tr>
          
          
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)


import {
mapGetters,
mapActions
} from 'vuex'
import GeneralDashboardLayout from "@/components/layouts/GeneralDashboardLayout";
import TogglePrimary from "@/components/Commons/TogglePrimary";
import _ from "lodash";
import BackButton from "@/components/Commons/BackButton";

import { isPermits} from "@/services/CheckPermissions";
import headerForm from "@/components/cruds/EventAnalytics/Forms/Header";
import TabForm from "@/components/cruds/EventAnalytics/Forms/TabEventHall";
import { ref } from "vue";
import { utils, writeFileXLSX } from 'xlsx';

export default {
name: 'LpIndex',
components: {
   
},
data() {
return {
    search: null,
    perPage: 5,
    system_users: [],
   }
},
watch: {
},
created() {
// this.fetchPermissions()
/*let postData = {event_id:this.$route.params.event_id,event_type:"Event-Hall"}
console.log("Post Data",postData);
this.onChangeEventHallData(postData)
.catch(() => {
    this.$flashMessage.show({
        group: 'event_assets_index',
        type: 'error',
        title: 'Error',
        text: 'Something went wrong.'
    });
})*/

},
beforeUnmount() {
//this.resetState();
//delete this.$flashMessage.groups.event_assets_index;

},
computed: {
...mapGetters('EventAnalyticsIndex', ['loading', 'all', 'headers','enumModules','loaded','chartEventHall']),
},
methods: {
...mapActions('EventAnalyticsIndex', ['onChangeEventHallData','onChangefetchData','fetchData','resetState','getEventUserTimeSpentReport','generateLivePresentationsSheet']),
createClick() {
    this.setIsNew(true);
    this.setIsEditing(false);
},
cancelClick() {
    this.resetState();
},
perRowChange(e) {
    this.perPage = Number(e.target.value);
},

async exportFile() {

     let postData = {
      eventId: this.$route.params.event_id,
      event_type: 'Event-Users',
    };

    const response = await this.getEventUserTimeSpentReport(postData);
    const event_users = response.data.data;

    // 🧩 1. Create a summary section (basic event info)
    const basicInfo = [
      ["Event Time Analytics Report"],
      ["Generated On", new Date().toLocaleString()],
      ["Event ID", this.$route.params.event_id],
      [],
      ["User Email", "First Name", "Last Name", "Company Name", "Date", "Total Time (Minutes)"],
    ];

    // 🧩 2. Flatten the user session data for export
    const formattedData = [];

    event_users.forEach(user => {
      formattedData.push({
        "User Email": user.user_email,
        "First Name": user.user_first_name,
        "Last Name": user.user_last_name,
        "Company Name": user.user_company_name,
        "Date": user.date,
        "Total Time (Minutes)": user.total_time_spent_minutes,
      });

      // Optional: include sessions as detail rows
      user.sessions.forEach(session => {
        formattedData.push({
          "User Email": "",
          "First Name": "",
          "Last Name": "",
          "Company Name": "",
          "Date": "",
          "Total Time (Minutes)": "",
          "Session ID": session.session_id,
          "Login Time": session.login_time,
          "Logout Time": session.logout_time || "-",
          "Status": session.status,
          "Time Spent (Seconds)": session.time_spent_seconds,
          "Browser": session.browser,
          "Device Info": session.device_info,
          "IP Address": session.ip_address,
          "Country": session.location?.country || "-",
          "City": session.location?.city || "-",
        });
      });

      // Add a blank row after each user's data for readability
      formattedData.push({});
    });

    // 🧩 3. Convert to worksheet
    const summarySheet = utils.aoa_to_sheet(basicInfo);
    const dataSheet = utils.json_to_sheet(formattedData, { origin: -1 }); // append after summary

    // Merge both parts (summary + data)
    const finalSheet = Object.assign(summarySheet, dataSheet);

    // 🧩 4. Create workbook & append sheet
    const wb = utils.book_new();
    utils.book_append_sheet(wb, finalSheet, "Event Users");

    // 🧩 5. Export to Excel
    writeFileXLSX(wb, "EventUsers_TimeAnalytics.xlsx");

    console.log("✅ Excel exported successfully!");
}

}



}
</script>

<style lang="scss" scoped>


.report-section {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.report-title {
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 20px;
  color: #333;
}

.report-table-container {
  overflow-x: auto;
}

.report-table {
  width: 100%;
  border-collapse: collapse;
  background: #fafafa;
}

.report-table th,
.report-table td {
  text-align: left;
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
  font-size: 0.95rem;
}

.report-table th {
  background: #f3f4f6;
  color: #555;
  font-weight: 600;
}

.report-table tr:hover {
  background: #f9fafb;
}

.download-icon {
  font-size: 1.4rem;
  color: #007bff;
  cursor: pointer;
  transition: color 0.2s ease;
}

.download-icon:hover {
  color: #0056b3;
}

</style>
